// Preserve dormant choices in the UI, but never send incompatible filters.
export function activeAtlasFilters(filters) {
  const result = { ...filters };
  if (['livestock','mushrooms'].includes(filters.activity)) {
    for (const key of ['crop', 'icc_code', 'reference_crop_id', 'reference_domain', 'species_id', 'cultivar_id', 'cultivar_name_key', 'variety']) delete result[key];
    if(filters.activity === 'mushrooms') delete result.animal_species_id;
  } else if (['agriculture', 'gardens', 'ornamental', 'forestry', 'nursery', 'green_spaces', 'truffles'].includes(filters.activity)) {
    delete result.animal_species_id;
    if (['ornamental', 'forestry', 'green_spaces', 'truffles'].includes(filters.activity)) {
      for (const key of ['crop', 'icc_code', 'reference_crop_id']) delete result[key];
      if(!['green_spaces','truffles'].includes(filters.activity)) result.reference_domain = 'forest_ornamental';
    }
  }
  return result;
}

